<script lang="ts">
    import { Link } from "svelte-navigator";
    import {Git4} from "@anyways-open/common-svgs";
    import type { ProjectData } from "../../api/projects/data/projects/ProjectData";
    import { appManager } from "../../AppManager";
    import { get } from "svelte/store";
    import ProjectLink from "../../shared/links/ProjectLink.svelte";

    export let projectData: ProjectData;

    let currentUserIsAdmin = appManager.getCurrentUserAdminStore();

    let organization = "";
    let project = "";

    $: if (typeof projectData !== "undefined")
        organization = projectData.organization?.name ?? "";
    $: if (typeof projectData !== "undefined")
        project = projectData.name;

</script>

<header class="bg-dark pt-9 pb-11 d-none d-md-block">
    <div class="container-md">
        <div class="row align-items-center">
            <div class="col">
                <h1 class="fw-bold text-white mb-2">{@html projectData?.name ?? ""}</h1>
                <div class="text-white">{@html projectData?.description ?? ""}</div>
            </div>
            {#if $currentUserIsAdmin}
            <h3 class="col-auto">
                <ProjectLink {projectData}></ProjectLink> /
                <Link to=".">{project}</Link>
                <Git4 />
            </h3>
            {:else}
            <h3 class="col-auto">
                {organization} /
                <Link to=".">{project}</Link>
                <Git4 />
            </h3>
            {/if}
        </div>
    </div>
</header>
